import React from 'react';
import { Button, Card, CardBody, CardHeader, FormGroup, Input, Label } from 'reactstrap';
import { Option } from '../../../../models/formModel';

interface Props {
  search: string;
  startDate: string;
  endDate: string;
  selectedStatus: string;
  selectedLine: string;
  selectedResponsibleId: string;
  responsibleOptions: Option[];
  isLoadingResponsibles?: boolean;
  onSearchChange: (search: string) => void;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onStatusChange: (status: string) => void;
  onLineChange: (line: string) => void;
  onResponsibleChange: (responsibleId: string) => void;
  onClearFilters: () => void;
}

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'contacted', label: 'Contactado' },
  { value: 'could_not_contact', label: 'Sin contactar' },
  { value: 'contact_updated', label: 'Contacto actualizado' },
  { value: 'advisory_scheduled', label: 'Asesoría agendada' },
  { value: 'visit_scheduled', label: 'Visita agendada' },
  { value: 'applies', label: 'Aplica' },
  { value: 'does_not_apply', label: 'No aplica' },
  { value: 'cancelled', label: 'Cancelado' },
  { value: 'successful', label: 'Exitoso' },
  { value: 'paid', label: 'Pagado' },
];

const LINE_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'buyer', label: 'Comprador' },
  { value: 'tenant', label: 'Inquilino' },
  { value: 'supply_sales', label: 'Supply Sales' },
  { value: 'supply_rents', label: 'Supply Rents' },
];

const ReferralFilterBar: React.FC<Props> = ({
  search,
  startDate,
  endDate,
  selectedStatus,
  selectedLine,
  selectedResponsibleId,
  responsibleOptions,
  onSearchChange,
  onStartDateChange,
  onEndDateChange,
  onStatusChange,
  onLineChange,
  onResponsibleChange,
  onClearFilters,
}) => {
  return (
    <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '12px' }}>
      <CardHeader className="border-0 bg-white py-3 px-4 d-flex justify-content-between align-items-center" style={{ borderRadius: '12px 12px 0 0' }}>
        <label className="form-control-label mb-0">
          Filtros de búsqueda
        </label>
        <Button
          color="secondary"
          outline
          size="sm"
          style={{
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 12,
            padding: '4px 14px',
            boxShadow: 'none',
          }}
          onClick={onClearFilters}
        >
          <i className="fas fa-eraser mr-1" />
          Limpiar filtros
        </Button>
      </CardHeader>

      <CardBody className="pt-0 pb-3 px-4">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: 12,
            background: '#f4f6fa',
            padding: '14px 18px',
            borderRadius: 10,
            fontSize: 13,
          }}
        >
          {/* Buscar */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Buscar
            </Label>
            <Input
              type="text"
              placeholder="Referidor o prospecto..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Fecha Inicio */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Fecha desde
            </Label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Fecha Fin */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Fecha hasta
            </Label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            />
          </FormGroup>

          {/* Estado */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Estado
            </Label>
            <Input
              type="select"
              value={selectedStatus}
              onChange={(e) => onStatusChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {/* Línea */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Línea
            </Label>
            <Input
              type="select"
              value={selectedLine}
              onChange={(e) => onLineChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            >
              {LINE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {/* Responsable */}
          <FormGroup className="mb-0">
            <Label style={{ fontWeight: 500, fontSize: 12, marginBottom: 4 }}>
              Responsable
            </Label>
            <Input
              type="select"
              value={selectedResponsibleId}
              onChange={(e) => onResponsibleChange(e.target.value)}
              style={{ fontSize: 12, height: 34, borderRadius: 6 }}
            >
              <option value="">Todos</option>
              {responsibleOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </div>
      </CardBody>
    </Card>
  );
};

export default ReferralFilterBar;
